import React from 'react';
import { Button, Form, Input, Segment, TextArea, Grid } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import axios from 'axios';
import { toast } from 'react-toastify';

const mandatory = [
    {
        key: 1,
        value: 1,
        text: 'obavezni'
    },
    {
        key: 2,
        value: 2,
        text: 'izborni'
    }
];

export default class CreateNewGrade extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            comment: '',
            courseName: '',
            courseNameEn: '',
            courseNameOther: '',
            code: '',
            exerciseNumber: '',
            lectureNumber: '',
            ects: '',
            type: '',
            grade: '',
            otherLang: '',
            otherLangOptions: [],

            mob: JSON.parse(localStorage.getItem('mob')),

            courseErr: false,
            courseNameEnErr: false,
            courseNameOtherErr: false,
            codeErr: false,
            exerciseNumberErr: false,
            lectureNumberErr: false,
            ectsErr: false,
            typeErr: false,
            gradeErr: false,
            otherLangErr: false,
            startDateErr: false,

        };
        this.fetchMarkOptions = this.fetchMarkOptions.bind(this);
        this.closeAddMode = this.closeAddMode.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.addGrade = this.addGrade.bind(this);
        this.fetchLangOptions = this.fetchLangOptions.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.fetchMarkOptions();
        this.fetchLangOptions();
    }

    fetchLangOptions() {
        axios.get('/languages')
            .then(res => {
                this.setState({
                    otherLangOptions: res.data.map(el => ({
                        key: el.id,
                        value: el.twoLetterCode,
                        text: el.name
                    })),
                    otherLang: this.state.mob.translations.filter((e) => e.originalLanguage === true)[0].language
                    // otherLang: this.state.mob.country.officialLanguage.twoLetterCode
                });
            });
    }
    fetchMarkOptions() {
        axios.get('/marks')
            .then(res => {
                this.setState({
                    markOptions: res.data.map(el => ({
                        key: el.id, value: el.id, text: el.displayName
                    }))
                });
            });
    }

    closeAddMode() {
        this.props.closeAddMode();
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }
    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    resetForm() {
        this.setState({

            courseName: null,
            courseNameEn: null,
            courseNameOther: null,
            otherLang: null,
            code: null,
            exerciseNumber: null,
            lectureNumber: null,
            ects: null,
            type: null,
            grade: null,
            startDate: null,
            comment: null,

        });
    }

    addGrade() {
        if (!this.state.courseName || !this.state.code || !this.state.lectureNumber || !this.state.exerciseNumber
            || !this.state.ects || !this.state.grade || !this.state.startDate
            // || (!this.state.courseNameEn && !this.state.courseNameOther && !this.state.otherLang)
            || (!this.state.courseNameEn && !this.state.courseNameOther)
            || (this.state.courseNameEn && this.state.courseNameOther && !this.state.otherLang)
            || (!this.state.courseNameEn && this.state.courseNameOther && !this.state.otherLang)) {
            if (!this.state.courseNameEn && !this.state.courseNameOther) {
                toast('Niste unijeli sve podatke. Unesite barem jedan prevod za predmet.');
            } else { toast('Niste unijeli sve podatke'); }
            if (!this.state.courseName) { this.setState({ courseErr: true }); } else { this.setState({ courseErr: false }); }
            if (!this.state.code) { this.setState({ codeErr: true }); } else { this.setState({ codeErr: false }); }
            if (!this.state.lectureNumber) { this.setState({ lectureNumberErr: true }); } else { this.setState({ lectureNumberErr: false }); }
            if (!this.state.exerciseNumber) { this.setState({ exerciseNumberErr: true }); } else { this.setState({ exerciseNumberErr: false }); }
            if (!this.state.ects) { this.setState({ ectsErr: true }); } else { this.setState({ ectsErr: false }); }
            if (!this.state.grade) { this.setState({ gradeErr: true }); } else { this.setState({ gradeErr: false }); }
            if (!this.state.startDate) { this.setState({ startDateErr: true }); } else { this.setState({ startDateErr: false }); }
            if (!this.state.courseNameEn && !this.state.courseNameOther && !this.state.otherLang) { this.setState({ courseNameEnErr: true, courseNameOtherErr: true, otherLangErr: true }); } else { this.setState({ courseNameEnErr: false, courseNameOtherErr: false, otherLangErr: false }); }
            if (!this.state.courseNameEn && !this.state.courseNameOther && this.state.otherLang) { this.setState({ courseNameOtherErr: true }); }
            if (!this.state.courseNameEn && this.state.courseNameOther && !this.state.otherLang) { this.setState({ otherLangErr: true }); }
            if (this.state.courseNameOther && !this.state.otherLang) { this.setState({ otherLangErr: true }); }
            if (!this.state.courseNameOther && this.state.otherLang) { this.setState({ courseNameOtherErr: true }); }
        } else {
            this.setState({ loader: true });
            let transaltions = [];
            if (this.state.courseNameEn && this.state.otherLang !== 'en') {
                transaltions.push({
                    language: { twoLetterCode: this.state.otherLangOptions.filter((e) => e.value === 'en') ? this.state.otherLangOptions.find((e) => e.value === 'en').value : null },
                    courseName: this.state.courseNameEn
                });
            }
            if (this.state.courseNameOther) {
                transaltions.push({
                    language: { twoLetterCode: this.state.otherLang },
                    courseName: this.state.courseNameOther
                });
            }
            this.state.courseNameOther === '' ? localStorage.setItem('official', false): localStorage.setItem('official', true);

            let obj = {
                studentStudyProgramMobility: { id: this.state.mob.id },
                courseName: this.state.courseName,
                code: this.state.code,
                lectureNumber: this.state.lectureNumber,
                exerciseNumber: this.state.exerciseNumber,
                ects: this.state.ects,
                mandatory: this.state.type === 2 ? 0 : this.state.type === 1 ? 1 : null,
                mark: { id: this.state.grade },
                date: this.state.startDate,
                comment: this.state.comment,
                translations: transaltions
            };
            axios.post('/student-mobility-mark/add/', { ...obj }).then((res) => {
                toast('Uspješno ste unijeli ocjenu za odabranu mobilnost!');
                this.setState({ loader: false });
                this.resetForm();
                this.closeAddMode();
                this.props.getMobilityMark();
            }).catch(() => {
                this.setState({ loader: false });
                toast('Došlo je do greške! Studentu nije unešena ocjena.');
            });
        }
    }

    render() {
        // console.log('nn', this.state.mob.country.officialLanguage.twoLetterCode);
        // console.log('tt', this.state.otherLangOptions);
        // console.log('vv', this.state.otherLangOptions.filter((e) => (e.value === this.state.mob.country.officialLanguage.twoLetterCode)));
        return (
            <div>
                <Segment.Group secondary>
                    <Segment secondary clearing>
                        <Form noValidate>
                            <Grid columns={2} centered className="stackable">
                                <Grid.Row stretched>
                                    <Grid.Column>
                                        <Form.Field
                                            required
                                            control={Input}
                                            label="Predmet (B/H/S)"
                                            value={this.state.courseName}
                                            onChange={(e) => this.setState({ courseName: e.target.value })}
                                            name="course"
                                            placeholder="Unesite naziv predmeta"
                                            error={this.state.courseErr}
                                        />
                                        <Form.Field
                                            control={Input}
                                            label="Predmet (engleski jezik)"
                                            value={this.state.courseNameEn}
                                            onChange={(e) => this.setState({ courseNameEn: e.target.value })}
                                            name="courseNameEn"
                                            placeholder="Unesite naziv predmeta"
                                            error={this.state.courseNameEnErr}
                                            disabled={this.state.otherLang === 'en'}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Segment>
                                            <Form.Field error={this.state.otherLangErr}>
                                                <label>Izvorni jezik</label>
                                                <Form.Dropdown
                                                    clearable
                                                    selection
                                                    placeholder="Odaberite izvorni jezik"
                                                    value={this.state.otherLang}
                                                    onChange={this.handleInputChange}
                                                    name="otherLang"
                                                    options={this.state.otherLangOptions.filter((e) => (e.value === this.state.mob.translations.filter((e) => e.originalLanguage === true)[0].language))}
                                                    // options={this.state.otherLangOptions.filter((e) => (e.value === this.state.mob.country.officialLanguage.twoLetterCode))}
                                                    // options={this.state.otherLangOptions.filter((e) => (e.value !== 'en' && e.value !== 'bs'))}
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>
                                            <Form.Field
                                                control={Input}
                                                label="Predmet (izvorni jezik)"
                                                value={this.state.courseNameOther}
                                                onChange={(e) => this.setState({ courseNameOther: e.target.value })}
                                                name="courseNameOther"
                                                placeholder="Unesite naziv predmeta"
                                                error={this.state.courseNameOtherErr}
                                            />
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <Grid columns={4} centered className="stackable">
                                <Grid.Row stretched>
                                    <Grid.Column>
                                        <Form.Field
                                            required
                                            control={Input}
                                            label="Šifra predmeta"
                                            value={this.state.code}
                                            onChange={(e) => this.setState({ code: e.target.value })}
                                            name="code"
                                            placeholder="Unesite šifru predmeta"
                                            error={this.state.codeErr}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field
                                            required
                                            control={Input}
                                            label="Broj predavanja"
                                            value={this.state.lectureNumber}
                                            type="number"
                                            onChange={(e) => this.setState({ lectureNumber: e.target.value })}
                                            name="lectureNumber"
                                            placeholder="Unesite broj predavanja"
                                            error={this.state.lectureNumberErr}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field
                                            required
                                            control={Input}
                                            label="Broj vježbi"
                                            value={this.state.exerciseNumber}
                                            type="number"
                                            onChange={(e) => this.setState({ exerciseNumber: e.target.value })}
                                            name="exerciseNumber"
                                            placeholder="Unesite broj vježbi"
                                            error={this.state.exerciseNumberErr}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field
                                            required
                                            control={Input}
                                            label="ECTS"
                                            value={this.state.ects}
                                            type="float"
                                            onChange={(e) => this.setState({ ects: e.target.value })}
                                            name="ects"
                                            placeholder="Unesite broj ECTS-a"
                                            error={this.state.ectsErr}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <Grid columns={3} centered className="stackable">
                                <Grid.Row stretched>
                                    <Grid.Column>
                                        <Form.Field
                                            required
                                            control={DateTimePicker}
                                            label="Datum ocjene"
                                            format="D. M. YYYY."
                                            defaultValue={this.state.startDate}
                                            placeholder="Unesite datum ocjene"
                                            value={this.state.startDate}
                                            time={false}
                                            onChange={this.handleDateChange.bind(null, 'startDate')}
                                            style={{ borderWidth: '0px' }}
                                            error={this.state.startDateErr}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field required error={this.state.gradeErr}>
                                            <label>Ocjena</label>
                                            <Form.Dropdown
                                                clearable
                                                selection
                                                placeholder="Odaberite ocjenu"
                                                value={this.state.grade}
                                                onChange={this.handleInputChange}
                                                name="grade"
                                                options={this.state.markOptions}
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field error={this.state.typeErr}>
                                            <label>Tip predmeta</label>
                                            <Form.Dropdown
                                                clearable
                                                selection
                                                placeholder="Odaberite tip predmeta"
                                                value={this.state.type}
                                                onChange={this.handleInputChange}
                                                name="type"
                                                options={mandatory}
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <Grid columns={1} centered className="stackable">
                                <Grid.Row stretched>
                                    <Grid.Column>
                                        <Form.Field
                                            label="Komentar"
                                            control={TextArea}
                                            name="comment"
                                            rows={1}
                                            value={this.state.comment}
                                            onChange={this.handleInputChange}
                                            placeholder="Unesite komentar..."
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <br />
                            <Button color="blue" basic="true" floated="right" onClick={this.closeAddMode}>Odustani</Button>
                            <Button
                                color="blue"
                                floated="right"
                                onClick={this.addGrade}
                            >
                                Dodaj
                            </Button>
                        </Form>
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/CreateNewGrade.js